<template>
  <Notifications />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import Notifications from "@/components/content/Notifications.vue";

export default defineComponent({
  name: 'NotificationsView',
  components: {Notifications},

  setup(props, context) {
    const i18n = useI18n()

    context.emit('pageName', i18n.t('aside.menu.pages.notifications'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.notifications'))
    })
  }
})
</script>